// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"72709b4d","812":"02414e9d"}[chunkId] + ".chunk.js";
};